
import { Vue, prop } from "vue-class-component";
import { HangingOutgoingSummary } from '@/domain/entities/HangingOutgoing';
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  dataSummary = prop<HangingOutgoingSummary>({
    default: () => ({}),
    type: Object,
  });
}

class HeaderSummaryHangingOutgoing extends Vue.with(Props) {
  formatDate = formatDate

  get allCards() {
    // summary cards
   return [
      {
        icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
        alt: "total-active-hanging-outgoing",
        label: this.$t("dashboard.hanging.activity"),
        pending: this.dataSummary.pendingActitivies,
        done: this.dataSummary.doneActivities,
        total: this.dataSummary.totalActivities,
      },
      {
        icon: require("@/app/ui/assets/svg/ic_pic_hanging.svg"),
        alt: "total-user-ops-hanging-outgoing",
        label: this.$t("dashboard.hanging.userOps"),
        pending: this.dataSummary.pendingUserOps,
        done: this.dataSummary.doneUserOps,
        total: this.dataSummary.totalUserOps,
      },
      {
        icon: require("@/app/ui/assets/svg/del-hanging.svg"),
        alt: "total-sti-hanging-outgoing",
        label: "STI",
        pending: this.dataSummary.pendingSTI,
        done: this.dataSummary.doneSTI,
        total: this.dataSummary.totalSTI,
      },
      {
        icon: require("@/app/ui/assets/svg/total-bag-hanging.svg"),
        alt: "total-bagging-hanging-outgoing",
        label: "BAGGING",
        pending: this.dataSummary.pendingBAGGING,
        done: this.dataSummary.doneBAGGING,
        total: this.dataSummary.totalBAGGING,
      },
      {
        icon: require("@/app/ui/assets/svg/total-stt-hanging.svg"),
        alt: "total-stt-hanging-outgoing",
        label: "STT",
        pending: this.dataSummary.pendingSTT,
        done: this.dataSummary.doneSTT,
        total: this.dataSummary.totalSTT,
      },
    ];
  }
}

export default HeaderSummaryHangingOutgoing;
